var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _header = _interopRequireDefault(require("./header"));

var _Events = _interopRequireDefault(require("../../Liveticker/Commentary/Events"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/ConferenceTicker/Commentary/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ConferenceTickerCommentary = function (_React$Component) {
  (0, _inherits2.default)(ConferenceTickerCommentary, _React$Component);

  var _super = _createSuper(ConferenceTickerCommentary);

  function ConferenceTickerCommentary() {
    (0, _classCallCheck2.default)(this, ConferenceTickerCommentary);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ConferenceTickerCommentary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          match = _this$props.match,
          commentary = _this$props.commentary,
          matchComponent = _this$props.matchComponent,
          eventStyles = _this$props.eventStyles;
      if (!commentary) return null;
      return _react.default.createElement(_Events.default, (0, _extends2.default)({}, commentary, {
        match: _react.default.createElement(_header.default, {
          match: match,
          matchComponent: matchComponent,
          matchMinute: commentary.matchMinute,
          homeScore: commentary.scoreHome,
          awayScore: commentary.scoreAway,
          type: commentary.type,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 21
          }
        })
      }, eventStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20,
          columnNumber: 13
        }
      }));
    }
  }]);
  return ConferenceTickerCommentary;
}(_react.default.Component);

exports.default = ConferenceTickerCommentary;
ConferenceTickerCommentary.propTypes = {
  match: _propTypes.default.object.isRequired,
  commentary: _propTypes.default.object.isRequired,
  eventStyles: _propTypes.default.object,
  matchComponent: _propTypes.default.func
};